module.exports = __webpack_public_path__ + "static/media/TrojanCitizen.15947376.jpg";